// Recipe / action requirements. Parsed from NEU `crafttext` ("Requires: Diamond IV", "Requires: Gemstone X & HotM 5",
// "Requires Coal IV"), `slayer_req` ("WOLF_6") and `reputation_req` ("BARBARIAN:7500").
export const DEFAULT_PROFILE = {
    hotmTier: 0, quickForgeLevel: 0, enchantingLevel: 0, collections: {}, slayers: {}, skills: {}, reputation: {},
    xpLevels: 0, coleMoltenForge: false, quadTaxes: false, npcShoppingSpree: false, ignoreRequirements: true,
};
const ROMAN = { I: 1, V: 5, X: 10, L: 50, C: 100 };
export function roman(s) {
    if (/^\d+$/.test(s))
        return Number(s);
    if (!/^[IVXLC]+$/.test(s))
        return null;
    let total = 0;
    for (let i = 0; i < s.length; i++) {
        const v = ROMAN[s[i]], next = ROMAN[s[i + 1] ?? ""] ?? 0;
        total += v < next ? -v : v;
    }
    return total;
}
const SLAYER_NAMES = { ZOMBIE: "Zombie", SPIDER: "Spider", WOLF: "Wolf", EMAN: "Enderman", ENDERMAN: "Enderman", BLAZE: "Blaze", VAMPIRE: "Vampire" };
export function parseCraftText(text) {
    if (!text)
        return [];
    const body = text.replace(/^Requires:?\s*/i, "").trim();
    if (!body)
        return [];
    return body.split(/\s*&\s*|\s*,\s*/).filter(Boolean).map((part) => {
        let m = /^HotM\s+(\d+)$/i.exec(part);
        if (m)
            return { type: "hotm", tier: Number(m[1]), text: part };
        m = /^(.+?) Slayer\s+([IVXLC\d]+)$/.exec(part);
        if (m)
            return { type: "slayer", name: m[1], level: roman(m[2]) ?? 0, text: part };
        m = /^(.+?)\s+([IVXLC]+|\d+)$/.exec(part);
        if (m && roman(m[2]) != null)
            return { type: "collection", name: m[1], tier: roman(m[2]), text: `${part} collection` };
        return { type: "unverified", text: part };
    });
}
export function parseSlayerReq(req) {
    if (!req)
        return [];
    const m = /^([A-Z]+)_(\d+)$/.exec(req);
    if (!m)
        return [{ type: "unverified", text: `slayer ${req}` }];
    const name = SLAYER_NAMES[m[1]] ?? m[1];
    return [{ type: "slayer", name, level: Number(m[2]), text: `${name} Slayer ${m[2]}` }];
}
export function parseReputationReq(req) {
    if (!req)
        return [];
    const m = /^([A-Z_]+):(\d+)$/.exec(req);
    if (!m)
        return [{ type: "unverified", text: `reputation ${req}` }];
    const faction = m[1].charAt(0) + m[1].slice(1).toLowerCase();
    return [{ type: "reputation", faction, amount: Number(m[2]), text: `${faction} reputation ${m[2]}` }];
}
/** true = met, false = not met, null = cannot be checked (unverified text or unknown profile value). */
export function isMet(r, p) {
    switch (r.type) {
        case "hotm": return p.hotmTier >= r.tier;
        case "collection": {
            const have = p.collections[r.name];
            return have == null ? false : have >= r.tier;
        }
        case "slayer": return (p.slayers[r.name] ?? 0) >= r.level;
        case "skill": return (p.skills?.[r.name] ?? 0) >= r.level;
        case "reputation": return (p.reputation[r.faction] ?? 0) >= r.amount;
        case "enchanting": return p.enchantingLevel >= r.level;
        case "xp_levels": return p.xpLevels >= r.levels;
        case "forge": return p.hotmTier >= 2;
        default: return null;
    }
}
export function unmet(reqs, p) {
    if (p.ignoreRequirements)
        return [];
    return reqs.filter(r => isMet(r, p) === false);
}
export function dedupeRequirements(reqs) {
    const seen = new Map();
    for (const r of reqs) {
        const key = r.type === "collection" ? `c:${r.name}` : r.type === "hotm" ? "hotm" : r.type === "slayer" ? `s:${r.name}` : r.type === "skill" ? `k:${r.name}`
            : r.type === "enchanting" ? "ench" : r.type === "xp_levels" ? "xp" : r.text;
        const prev = seen.get(key);
        const rank = (x) => ("tier" in x ? x.tier : "level" in x ? x.level : "levels" in x ? x.levels : "amount" in x ? x.amount : 0);
        if (!prev || rank(r) > rank(prev))
            seen.set(key, r);
    }
    return [...seen.values()];
}
//# sourceMappingURL=requirements.js.map